export default __webpack_public_path__ + "static/media/Preview2.5174031a.jpg";